import { createStore } from 'vuex';
import { signInWithEmailAndPassword, createUserWithEmailAndPassword, signOut, sendPasswordResetEmail, onAuthStateChanged, getIdToken, sendEmailVerification } from 'firebase/auth';
import { auth, db } from '../main'; // importando auth do seu main.js
import { collection, query, where, getDocs, updateDoc, getDoc, doc, limit, addDoc } from 'firebase/firestore';
import { getTodayDateString, isCardDue } from '../utils/sm2';


import axios from 'axios';

const TABLE_URL = 'https://script.google.com/macros/s/AKfycbz2xew0Ie2dSXvXLXToc5oHE0icdWUdAoM9_YPlk_crczQ-IX3YJSfHT0RYPaMT9q1aaA/exec'
const TABLE_URL_FLASHCARDS = 'https://script.google.com/macros/s/AKfycbxSHd4bzoraHc6I24vqGdD0-peHOitLYPGMbAOpGUeu_SAh2MJNy0bskYaTdpGfg464FA/exec'

export default createStore({
  state: {
    loadedSimuladosThemes: {}, // Adiciona o estado para armazenar os temas dos simulados
    hasSubmittedLead: false,
    leadEmail: null,
    isRegisteringTrial: false,

    user: null,
    // substitui boolean por contador para evitar condições de corrida
    loadingCount: 0,
    error: false,
    userName: [],
    areas: [],
    flashcards: [],
    flashcardsV2: [],
    activeDeckV2: null,
    deckCardsPoolV2: [],
    loadedItems: [],
    questoesRespondidas: [],  // ← ADICIONE ESTA LINHA
    questoesErradas: [],  // ← ADICIONE ESTA LINHA
    challengeloadedItems: [],
    loadedRawQuestions: [],
    loadedGabarito: [],
    loadedGabaritoSimulados: [],
    loadedSimulados: [],
    loadedSimulados2: [],
    loadedSimuladosWrong: [],
    loadedSimuladosPraticoWrong: [],
    admin: "",
    freemium: "",
    dbName: "",
    challengedbName: "",
    noqName: "",
    challengenoqName: "",
    noqdName: "",
    challengenoqdName: "",
    challengenoqcorrectName: "",
    challengenoqwrongName: "",
    loadedResults: [],
    loadedCards: [],
    loadedSimuladosResults: [], // Adicionando o estado para resultados dos simulados
  },
  getters: {
    leadEmail(state) {
      return state.leadEmail;
    },
    questoesRespondidas(state) {
      return state.questoesRespondidas;
    },
    questoesErradas(state) {
      return state.questoesErradas;
    },
    user(state) {
      return state.user;
    },
    admin(state) {
      return state.admin
    },
    freemium(state) {
      return state.freemium
    },
    challengeProgress(state) {
      return state.challengeProgress
    },
    loading(state) {
      return (state.loadingCount || 0) > 0;
    },
    error(state) {
      return state.error;
    },
    userName(state) {
      return state.userName
    },
    areas(state) {
      return state.areas
    },
    flashcards(state) {
      return state.flashcards
    },
    flashcardsV2(state) {
      return state.flashcardsV2;
    },
    activeDeckV2(state) {
      return state.activeDeckV2;
    },
    deckCardsPoolV2(state) {
      return state.deckCardsPoolV2;
    },
    loadedItems(state) {
      return state.loadedItems
    },
    challengeloadedItems(state) {
      return state.challengeloadedItems
    },
    loadedRawQuestions(state) {
      return state.loadedRawQuestions
    },

    loadedGabarito(state) {
      return state.loadedGabarito
    },
    loadedGabaritoSimulados(state) {
      return state.loadedGabaritoSimulados
    },
    loadedSimulados(state) {
      return state.loadedSimulados
    },
    loadedSimuladosWrong(state) {
      return state.loadedSimuladosWrong
    },
    loadedSimuladosPraticoWrong(state) {
      return state.loadedSimuladosPraticoWrong
    },

    loadedSimulados2(state) {
      return state.loadedSimulados2
    },
    dbName(state) {
      return state.dbName
    },
    challengedbName(state) {
      return state.challengedbName
    },
    noqName(state) {
      return state.noqName
    },
    challengenoqName(state) {
      return state.challengenoqName
    },
    noqdName(state) {
      return state.noqdName
    },
    challengenoqdName(state) {
      return state.challengenoqdName
    },
    challengenoqcorrectName(state) {
      return state.challengenoqcorrectName

    },
    challengenoqwrongName(state) {
      return state.challengenoqwrongName
    },
    loadedResults(state) {
      return state.loadedResults
    },
    loadedCards(state) {
      return state.loadedCards
    },
    loadedSimuladosResults(state) {
      return state.loadedSimuladosResults;
    },
    loadedSimuladosThemes(state) {
      return state.loadedSimuladosThemes;
    },
  },
  mutations: {
    setRegisteringTrial(state, payload) {
      state.isRegisteringTrial = payload;
    },
    setLeadEmail(state, payload) {
      state.leadEmail = payload;
    },
    setHasSubmittedLead(state, payload) {
      state.hasSubmittedLead = payload;
    },
    setQuestoesRespondidas(state, payload) {
      state.questoesRespondidas = payload;
    },
    setQuestoesErradas(state, payload) {
      state.questoesErradas = payload;
    },
    clearQuestoesRespondidas(state) {
      state.questoesRespondidas = [];
    },
    setLoadedSimuladosThemes(state, payload) {
      state.loadedSimuladosThemes = payload;
    },
    setLoadedSimuladosResults(state, payload) {
      state.loadedSimuladosResults = payload;
    },
    setUser(state, payload) {
      state.user = payload;
    },
    setAdmin(state, payload) {
      state.admin = payload
    },
    setFreemium(state, payload) {
      state.freemium = payload
    },
    setchallengeProgress(state, payload) {
      state.challengeProgress = payload
    },
    setLoading(state, payload) {
      // payload: true -> inicia uma operação (incrementa)
      // payload: false -> finaliza uma operação (decrementa, não abaixo de 0)
      if (payload) {
        state.loadingCount = (state.loadingCount || 0) + 1;
      } else {
        state.loadingCount = Math.max(0, (state.loadingCount || 0) - 1);
      }
    },
    setError(state, payload) {
      if (payload.code == "auth/wrong-password") {
        payload.message = "Senha Incorreta."
      } else if (payload.code == "auth/network-request-failed") {
        payload.message = "Sem conexão."
      } else if (payload.code == "auth/user-not-found") {
        payload.message = "Usuário não encontrado."
      } else if (payload.code == "auth/too-many-requests") {
        payload.message = "Muitas tentativas incorretas. O acesso foi bloqueado temporariamente. Aguarde e tente novamente"
      } else if (payload.code == "auth/invalid-credential") {
        payload.message = "Verifique E-mail ou Senha"
      } else if (payload.code == "auth/invalid-login-credential") {
        payload.message = "Verifique E-mail ou Senha"
      } else if (payload.code == "auth/email-not-verified") {
        payload.message = "Por favor, verifique seu e-mail antes de acessar a plataforma."
      } else {
        payload.message = "Verifique E-mail ou Senha"
      }
      state.error = payload
    },
    setUserName(state, payload) {
      state.userName = payload
    },
    clearUserName(state) {
      state.userName = ""
    },
    setAreas(state, payload) {
      state.areas = payload
    },
    clearAreas(state) {
      state.areas = []
    },
    setFlashcards(state, payload) {
      state.flashcards = payload
    },
    clearFlashcards(state) {
      state.flashcards = []
    },
    setFlashcardsV2(state, payload) {
      state.flashcardsV2 = payload;
    },
    clearFlashcardsV2(state) {
      state.flashcardsV2 = [];
    },
    setActiveDeckV2(state, payload) {
      state.activeDeckV2 = payload;
    },
    setDeckCardsPoolV2(state, payload) {
      state.deckCardsPoolV2 = payload;
    },
    clearError(state) {
      state.error = false;
    },
    setLoadedResults(state, payload) {
      state.loadedResults = payload
    },
    setLoadedItems(state, payload) {
      state.loadedItems = payload
    },
    challengesetLoadedItems(state, payload) {
      state.challengeloadedItems = payload
    },
    setLoadedRawQuestions(state, payload) {
      state.loadedRawQuestions = payload
    },
    setLoadedGabarito(state, payload) {
      state.loadedGabarito = payload
    },
    setLoadedGabaritoSimulados(state, payload) {
      state.loadedGabaritoSimulados = payload
    },
    setLoadedSimulados(state, payload) {
      state.loadedSimulados = payload
    },
    setLoadedSimuladosWrong(state, payload) {
      state.loadedSimuladosWrong = payload
    },
    setLoadedSimuladosPraticoWrong(state, payload) {
      state.loadedSimuladosPraticoWrong = payload
    },
    setLoadedSimulados2(state, payload) {
      state.loadedSimulados2 = payload
    },
    setDbName(state, payload) {
      state.dbName = payload
    },
    challengesetDbName(state, payload) {
      state.challengedbName = payload
    },
    setNoqName(state, payload) {
      state.noqName = payload
    },
    challengesetNoqName(state, payload) {
      state.challengenoqName = payload
    },
    setNoqdName(state, payload) {
      state.noqdName = payload
    },
    challengesetNoqdName(state, payload) {
      state.challengenoqdName = payload
    },
    challengesetNoqcorrectName(state, payload) {
      state.challengenoqcorrectName = payload
    },
    challengesetNoqwrongName(state, payload) {
      state.challengenoqwrongName = payload
    },
    setLoadedCards(state, payload) {
      state.loadedCards = payload
    },
    clearLoadedItems(state) {
      state.loadedItems = []
    },
    clearLoadedRawQuestions(state) {
      state.loadedRawQuestions = []
    },
    clearLoadedGabarito(state) {
      state.loadedGabarito = []
    },
    clearloadedResults(state) {
      state.loadedResults = []
    },
    cleardbName(state) {
      state.dbName = null
    },
    clearnoqName(state) {
      state.noqName = null
    },
    clearnoqdName(state) {
      state.noqdName = null
    }
  },

  actions: {

    async registerTrialUser({ commit, dispatch }, payload) {
      commit('setLoading', true);
      commit('clearError');
      commit('setRegisteringTrial', true);
      try {
        const userCredential = await createUserWithEmailAndPassword(auth, payload.email, payload.password);
        const user = userCredential.user;

        // Envia o e-mail de verificação
        await sendEmailVerification(user);

        await addDoc(collection(db, "users"), {
          creationDate: new Date(),
          email: payload.email,
          name: payload.fullName,
          demoStartDate: new Date(),
          uid: user.uid
        });

        // Continuar enviando para a planilha (Google Sheets)
        await dispatch('postLeadDatafreemium', payload);

        await signOut(auth);

        commit('setLoading', false);
        commit('setRegisteringTrial', false);
        return true;
      } catch (error) {
        commit('setLoading', false);
        commit('setError', error);
        commit('setRegisteringTrial', false);
        throw error;
      }
    },

    async postLeadDatafreemium({ commit }, payload) {
      commit('setLoading', true);
      commit('setLeadEmail', payload.email);
      payload.action = 'saveFreemiumLead';

      return axios.get(TABLE_URL, { params: payload }, {
        headers: {
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': '0'
        }
      })
        .then(async (response) => {
          if (response.status < 400) {
            console.log('Lead saved:', response.data);
            commit('setHasSubmittedLead', true);
            commit('setLoading', false);
            return response.data;
          } else {
            console.error('Erro na requisição para salvar lead:', response.status);
            commit('setLoading', false);
            throw new Error(`Request failed with status ${response.status}`);
          }
        })
        .catch((error) => {
          console.error('Erro na requisição para salvar lead:', error.message);
          commit('setLoading', false);
          throw error;
        });
    },


    async postLeadData({ commit }, payload) {
      commit('setLoading', true);
      commit('setLeadEmail', payload.email);
      payload.action = 'saveTECMLead';

      return axios.get(TABLE_URL, { params: payload }, {
        headers: {
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': '0'
        }
      })
        .then(async (response) => {
          if (response.status < 400) {
            console.log('Lead saved:', response.data);
            commit('setHasSubmittedLead', true);
            commit('setLoading', false);
            return response.data;
          } else {
            console.error('Erro na requisição para salvar lead:', response.status);
            commit('setLoading', false);
            throw new Error(`Request failed with status ${response.status}`);
          }
        })
        .catch((error) => {
          console.error('Erro na requisição para salvar lead:', error.message);
          commit('setLoading', false);
          throw error;
        });
    },

    async loadSimuladosThemes({ commit, state }, payload) {
      commit('setLoading', true); // Ativa o estado de carregamento
      //payload.email = auth.currentUser ? auth.currentUser.email : (this.state.leadEmail || ''); // Adiciona o email ao payload
      if (state.admin && state.admin !== '') {
        payload.db = state.admin
      }
      try {
        // Faz a requisição para obter os temas dos simulados
        const response = await axios.get(TABLE_URL + '?action=sendSimuladosThemes', { params: payload }, {
          headers: {
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': '0',
          },
        });

        if (response.status < 400) {
          // Salva os dados retornados no estado Vuex
          commit('setLoadedSimuladosThemes', response.data.items);
          console.log('Simulados Themes:', response.data.items);
        } else {
          console.error('Erro ao carregar os temas dos simulados');
        }
      } catch (error) {
        console.error('Erro na requisição de temas dos simulados:', error.message);
      } finally {
        commit('setLoading', false); // Desativa o estado de carregamento
      }
    },
    // Ação para revalidar o token
    async revalidateToken({ commit, state }) {
      //const auth = getAuth(); // obter instância do Firebase Auth
      // Verifique se o usuário está logado
      const user = auth.currentUser;
      if (user) {
        try {
          // Tente obter o token do usuário
          const idToken = await getIdToken(user, true); // 'true' força a revalidação do token

          // Se o token for válido, continue
          // console.log('Token validado com sucesso:', idToken); // <- Comentado para não poluir o console
          //return idToken;
        } catch (error) {
          commit('setLoading', false)

          console.error('Erro ao validar o token:', error);
          // Realiza o logout no caso de falha na validação
          // commit('setUser', null); // Limpa o estado do usuário
          //  signOut(auth); // Faz o logout no Firebase
          throw new Error('Erro ao validar o token'); // Lança um erro para ser tratado no guard

        }
      } else {
        commit('setLoading', false)

        console.log('Nenhum usuário logado');
        //commit('setUser', null); // Limpa o estado do usuário
        throw new Error('Nenhum usuário logado'); // Lança um erro para ser tratado no guard
        //commit('setUser', null); // Remover usuário do estado caso não esteja logado
      }
    },
    // Suas ações Vuex aqui
    async signUserIn({ commit }, { email, password }) {
      try {
        // console.log( auth );

        // Autentique o usuário com e-mail e senha
        const userCredential = await signInWithEmailAndPassword(auth, email, password);

        // Extraia o usuário da credencial
        const user = userCredential.user;

        // Regra de Data: Começamos a exigir verificação de e-mail em 11 de Agosto de 2026
        const featureStartDate = new Date('2026-08-11T00:00:00Z');
        const userCreationDate = new Date(user.metadata.creationTime);

        // Bloqueia se o email não for verificado E a conta foi criada após a data de início da regra
        if (!user.emailVerified && userCreationDate > featureStartDate) {
          const q = query(collection(db, 'users'), where('email', '==', user.email));
          const querySnapshot = await getDocs(q);
          let isTrial = false;
          querySnapshot.forEach(doc => {
            if (doc.data().demoStartDate) isTrial = true;
          });

          if (isTrial) {
            await signOut(auth);
            throw { code: "auth/email-not-verified", message: "Por favor, verifique seu e-mail antes de acessar a plataforma." };
          }
        }

        // Chame a mutação setUser para atualizar o estado do usuário
        console.log(user)
        commit('setUser', user);
        commit('clearError')
        // Retorne o usuário autenticado para outros fins, se necessário
        return user;
      } catch (error) {
        // Manipule os erros, se ocorrerem
        console.error('Erro ao fazer login:', error.message);
        commit('setLoading', false)
        commit('setError', error)
      }
    },

    async resendVerificationEmail({ commit }, { email, password }) {
      try {
        const userCredential = await signInWithEmailAndPassword(auth, email, password);
        const user = userCredential.user;
        await sendEmailVerification(user);
        await signOut(auth);
        return true;
      } catch (error) {
        console.error('Erro ao reenviar e-mail:', error.message);
        throw error;
      }
    },

    logout({ commit }) {
      try {
        // Autentique o usuário com e-mail e senha
        signOut(auth);
        // Extraia o usuário da credencial
        // Chame a mutação setUser para atualizar o estado do usuário
        //commit('setUser', user);
        commit('setUser', null);
        commit('setLoading', false);
        console.log("Logout executado");

      } catch (error) {
        // Manipule os erros, se ocorrerem
        console.error('Erro ao fazer logout:', error.message);
        throw error;
      }
    },

    async forgotPassword({ commit }, payload) {
      try {
        //console.log( auth );        
        // Autentique o usuário com e-mail e senha
        const userCredential = await sendPasswordResetEmail(auth, payload.email);
        console.log("Email enviado.")
        commit('clearError')
        // Retorne o usuário autenticado para outros fins, se necessário
      } catch (error) {
        // Manipule os erros, se ocorrerem
        console.error('Erro ao mudar a senha:', error.message);
        commit('setLoading', false)
        commit('setError', error)
      }
    },

    async autoSignIn({ commit }, payload) {
      if (payload) {
        const featureStartDate = new Date('2026-08-11T00:00:00Z');
        const userCreationDate = new Date(payload.metadata?.creationTime);

        if (payload.emailVerified === false && userCreationDate > featureStartDate) {
          const q = query(collection(db, 'users'), where('email', '==', payload.email));
          const querySnapshot = await getDocs(q);
          let isTrial = false;
          querySnapshot.forEach(doc => {
            if (doc.data().demoStartDate) isTrial = true;
          });

          if (isTrial) {
            await signOut(auth);
            commit('setUser', null);
            return;
          }
        }
        commit('setUser', { email: payload.email });
      }
    },

    async listenToAuthChanges({ commit }) {
      onAuthStateChanged(auth, async (user) => {
        if (user) {
          const featureStartDate = new Date('2026-08-11T00:00:00Z');
          const userCreationDate = new Date(user.metadata.creationTime);

          if (!user.emailVerified && userCreationDate > featureStartDate) {
            const q = query(collection(db, 'users'), where('email', '==', user.email));
            const querySnapshot = await getDocs(q);
            let isTrial = false;
            querySnapshot.forEach(doc => {
              if (doc.data().demoStartDate) isTrial = true;
            });

            if (isTrial) {
              await signOut(auth);
              commit('setUser', null);
              return;
            }
          }
          commit('setUser', { email: user.email });
        } else {
          commit('setUser', null);
        }
      });
    },

    //action to see users name
    async checkExistingUser({ commit, state }) {
      // Verifique se já temos o usuário salvo no estado antes de fazer a consulta
      if (state.userData) {
        console.log('Usuário já está carregado:', state.userData);
        return;
      }
      try {
        console.log(auth.currentUser.email)
        const usersRef = collection(db, 'users'); // Referência para a coleção 'users'
        const q = query(usersRef, where('email', '==', auth.currentUser.email)); // Consulta para buscar usuários com o email especificado
        const querySnapshot = await getDocs(q); // Obtém todos os documentos que correspondem à consulta
        const userDataArray = []; // Array para armazenar os dados dos usuários
        querySnapshot.forEach((doc) => {
          // Para cada documento, imprime apenas o nome do usuário
          console.log('Nome do usuário:', doc.data().name);
          userDataArray.push({
            firstName: doc.data().name,
            lastName: doc.data().lastName,
            userEmail: doc.data().email,
            userPhone: doc.data().phone,
            userAge: doc.data().age,
            userGender: doc.data().gender,
            totalCards: doc.data().totalCards || 0,
            totalCardsV2: doc.data().totalCardsV2 || 0,
            dates: doc.data().dates || [],
            datesV2: doc.data().datesV2 || [],
            demo: doc.data().demo,
            difficultyTracking: doc.data().difficultyTracking || [],
            difficultyTrackingV2: doc.data().difficultyTrackingV2 || [],
            lastcsat: doc.data().lastcsat, // Inclua o campo 'lastcsat' aqui
            totalsincecsat: doc.data().totalsincecsat // Inclua o campo 'lastcsat' aqui
          });
          console.log(userDataArray)
          commit('setUserName', userDataArray)
        });
      } catch (error) {
        console.error('Erro ao buscar usuários:', error.message);
        throw error;
      }

    },

    // Action to SAVE Profile data.
    async saveProfile({ commit }, payload) {
      try {
        // Adicione o email do usuário autenticado ao payload
        payload.email = auth.currentUser ? auth.currentUser.email : (this.state.leadEmail || '');

        // Referência para a coleção 'users'
        const usersRef = collection(db, 'users');
        console.log(payload.email);

        // Consulta para buscar o usuário com o email especificado
        const q = query(usersRef, where('email', '==', payload.email));

        // Obtenha os dados do usuário
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach(async (doc) => {
          const currentData = doc.data();

          // Verificar se o payload contém totalsincecsat igual a 0
          if (payload.totalsincecsat === 999) {
            // Zerar o campo totalsincecsat no Firebase
            await updateDoc(doc.ref, {
              ...payload, // Atualiza outros campos enviados no payload
              totalsincecsat: 0 // Zera o campo
            });
            console.log('totalsincecsat foi zerado.');
          } else {
            // Incrementar o valor de totalsincecsat, se ele existir
            const currentTotalSinceCSAT = currentData.totalsincecsat || 0; // Valor atual ou 0 se não existir
            const newTotalSinceCSAT = currentTotalSinceCSAT + (payload.totalsincecsat || 0); // Soma o valor enviado no payload

            // Atualize os campos do usuário com os dados do payload
            await updateDoc(doc.ref, {
              ...payload, // Atualiza outros campos enviados no payload
              totalsincecsat: newTotalSinceCSAT // Atualiza o valor incrementado
            });
            console.log('Perfil atualizado com sucesso:', { ...payload, totalsincecsat: newTotalSinceCSAT });
          }
        });
      } catch (error) {
        console.error('Erro ao salvar perfil:', error);
      }
    },

    // Action to SAVE CARDS TO USERS data.
    async saveCards({ commit }, payload) {
      try {
        // Adicione email e ação ao payload, se necessário
        payload.email = auth.currentUser ? auth.currentUser.email : (this.state.leadEmail || '');
        // Referência para a coleção 'users'
        const usersRef = collection(db, 'users');
        console.log(payload.email)
        //pega dado do vuex
        const userDataArray = this.state.userName; // Array para armazenar os dados dos usuários

        const currentDate = new Date();
        // Extract day, month, and year from the current date
        const day = currentDate.getDate();
        const month = currentDate.getMonth() + 1; // Month is zero-based, so add 1
        const year = currentDate.getFullYear();
        const currentDateStr = day + "/" + month + "/" + year;
        //const currentDateStr = "20" + "/" + month + "/" + year;

        console.log("Procurando por data:", currentDateStr);
        console.log(userDataArray[0]);

        // Verifica se a data atual está presente no array de datas
        let found = false;
        if (userDataArray.length > 0 && userDataArray[0].dates && Array.isArray(userDataArray[0].dates)) {
          let foundIndex = -1;
          userDataArray[0].dates.forEach((dateObj, index) => {
            if (dateObj.date === currentDateStr) {
              console.log("Encontrado");
              foundIndex = index;
              dateObj.cards += payload.total; // Atualiza o valor de cards
              return;
            }
          });

          if (foundIndex !== -1) {
            // Se encontrou a data, clona e usa o array atualizado
            payload.dates = [...userDataArray[0].dates]; // Agora contém a atualização
            userDataArray[0].dates = payload.dates; // ✓ ADICIONE ESTA LINHA
          } else {
            console.log("Não encontrado");
            // Se não encontrou, adiciona uma nova entrada ao array de datas
            payload.dates = [
              ...userDataArray[0].dates,
              {
                date: day + "/" + month + "/" + year,
                cards: payload.total
              }
            ];
            userDataArray[0].dates = payload.dates; // ✓ ADICIONE ESTA LINHA
          }
        }
        else {
          console.log("userDataArray nao encontrado")
          const date = [] //cria o array.
          date.push({
            date: day + "/" + month + "/" + year,
            cards: payload.total,
          });
          payload.dates = date;
          console.log("test", payload.dates)
          userDataArray[0].dates = date

        }

        // Check if userDataArray exists and userDataArray[0].totalCards is undefined
        if (userDataArray.length > 0 && userDataArray[0].totalCards === undefined) {
          console.log("userDataArray[0].totalCards is undefined");
          userDataArray[0].totalCards = 0
        } else {
          console.log("userDataArray[0].totalCards is defined");
          // Now you can proceed with your code logic
        }
        // Consulta para buscar usuários com o email especificado
        const q = query(usersRef, where('email', '==', payload.email));

        // Obtenha os dados do usuário
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach(async (doc) => {
          const currentData = doc.data();

          // Atualizar difficultyTracking
          let updatedDifficultyTracking = [...(currentData.difficultyTracking || [])];

          if (Array.isArray(payload.difficultyTracking)) {
            payload.difficultyTracking.forEach((newItem) => {
              const existingIndex = updatedDifficultyTracking.findIndex(item => item.refId === newItem.refId);

              if (existingIndex !== -1) {
                // Atualizar os campos do item existente
                updatedDifficultyTracking[existingIndex] = {
                  ...updatedDifficultyTracking[existingIndex],
                  ...newItem // Sobrescreve apenas os campos que estão no newItem
                };
              } else {
                // Adicionar o novo item se ele não existir
                updatedDifficultyTracking.push(newItem);
              }
            });
          }
          console.log("Updated Difficulty Tracking:", updatedDifficultyTracking);
          // Atualize os campos do usuário com os dados do payload
          await updateDoc(doc.ref, {
            totalCards: userDataArray[0].totalCards + payload.total,
            dates: payload.dates,
            difficultyTracking: updatedDifficultyTracking, // Adiciona o campo aqui

            // Adicione mais campos conforme necessário
          });
          // console.log(userDataArray)      
          userDataArray[0].totalCards = userDataArray[0].totalCards + payload.total
          userDataArray[0].difficultyTracking = updatedDifficultyTracking; // Atualiza o estado local

          console.log("debugging.")
          console.log(userDataArray)
          commit('setUserName', userDataArray)
        });
        // commit('profileSaved', payload);
      } catch (error) {
        console.error('Erro ao salvar perfil:', error);
        // Realize uma ação de tratamento de erro adequada, se necessário
      }
    },

    async saveDifficulty({ commit }, payload) { //revisar tudoooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooo
      console.log('executando......')
      try {
        // Referência para a subcoleção "GO15" dentro da coleção "flashcards/decks"
        const go15SubcollectionRef = collection(db, 'flashcards', 'decks', 'GO15');

        // Verificando se há documentos dentro da subcoleção "GO15"
        const go15SubcollectionSnapshot = await getDocs(go15SubcollectionRef);
        if (!go15SubcollectionSnapshot.empty) {
          console.log('Existem documentos dentro da subcoleção GO15.');
          // Se houver documentos, significa que há uma subcoleção dentro do documento GO15.
        } else {
          console.log('Não existem documentos dentro da subcoleção GO15.');
          // Se não houver documentos, significa que não há subcoleção dentro do documento GO15.
        }
      } catch (error) {
        console.error('Erro ao salvar os cards:', error);
        // Tratar o erro conforme necessário
      }
    },




    //action to get Cards Theme
    async getCards({ commit, state }) {
      console.log("lendo cards...")
      if (!state.areas || state.areas.length === 0) {
        commit('setLoading', true); // Only set loading if loadedItems is empty
      }
      // Adicione variáveis para manter as contagens das propriedades
      try {
        if (auth.currentUser) {
          const userEmail = auth.currentUser.email;
          console.log(userEmail);

          // Referência para o documento 'decks' dentro da coleção 'flashcards'
          const decksDocRef = doc(db, 'flashcards_TEMFC', 'decks');

          // Obtenha o documento 'decks'
          const decksDocSnap = await getDoc(decksDocRef);

          let areas = [];

          // Verifique se o documento 'decks' existe
          if (decksDocSnap.exists()) {
            // Lista de subcoleções a serem verificadas
            const subcollections = ['SuperIntensivo'];

            // Itere sobre as subcoleções
            for (const subcollection of subcollections) {
              // Referência para a subcoleção atual dentro do documento 'decks'
              const subcollectionRef = collection(decksDocRef, subcollection);

              // Obtenha os documentos dentro da subcoleção atual
              const docsSnap = await getDocs(subcollectionRef);

              // Itere sobre os documentos
              for (const docSnap of docsSnap.docs) {
                // Acesse cada documento
                const docData = docSnap.data();

                // Verifique se state.dbName é "TEMFC" e se o card tem agsus: true
                if (state.dbName === "TEMFC" && docData.agsus === true) {
                  continue; // Ignora este card
                }
                // Adicione a nova regra aqui
                // if (docData.area === "SuperIntensivo") {
                //   continue; // Ignora este card se a área for "SuperIntensivo"
                // }

                // Verifique se a propriedade 'area' existe no documento
                if (docData.area) {
                  let area = areas.find(item => item.nome === docData.area);

                  if (!area) {
                    area = {
                      nome: docData.area,
                      expanded: false,
                      subareas: [],
                      count: 0 // Inicialize a contagem para a área
                    };
                    areas.push(area);
                  }

                  let subarea = area.subareas.find(item => item.nome === docData.subArea);

                  if (!subarea) {
                    subarea = {
                      nome: docData.subArea,
                      expanded: false,
                      temas: [],
                      count: 0 // Inicialize a contagem para a subárea
                    };
                    area.subareas.push(subarea);
                  }

                  let tema = subarea.temas.find(item => item.nome === docData.theme);

                  if (!tema) {
                    tema = {
                      nome: docData.theme,
                      expanded: false,
                      subtemas: [],
                      count: 0 // Inicialize a contagem para o tema
                    };
                    subarea.temas.push(tema);
                  }

                  // Verifique se a propriedade 'subTheme' existe no documento
                  if (docData.subTheme) {
                    let subtema = tema.subtemas.find(item => item.nome === docData.subTheme);

                    if (!subtema) {
                      subtema = {
                        nome: docData.subTheme,
                        count: 0 // Inicialize a contagem para o subtema
                      };
                      tema.subtemas.push(subtema);
                    }
                    // Incrementar a contagem para o subtema
                    subtema.count++;
                  }

                  // Incrementar a contagem para cada propriedade encontrada
                  area.count++;
                  subarea.count++;
                  tema.count++;
                }
              }
            }
          } else {
            console.log('Documento "decks" não encontrado');
          }
          // Ordenar as subáreas alfabeticamente
          areas.forEach(area => {
            area.subareas.sort((a, b) => a.nome.localeCompare(b.nome));
          });
          // Exiba as áreas encontrados
          //console.log('Áreas encontradas:', areas);

          // Atualize o estado Vuex com as áreas e as contagens
          commit('setAreas', areas);
          commit('setLoading', false);
        } else {
          console.log('Usuário não autenticado');
        }
      } catch (error) {
        console.error('Erro ao buscar as áreas:', error.message);
        throw error;
      }
    },

    // Função para embaralhar um array usando o algoritmo de Fisher-Yates
    shuffleArray(array) {
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
      return array;
    },

    //Action for generate Cards to the quiz.
    async generateCards({ commit, state, getters }, payload) {
      try {
        const deckDocRef = doc(db, 'flashcards_TEMFC', 'decks');
        let querySnapshot;
        const cards = [];

        const subcollections = ['SuperIntensivo'];

        for (const subcollection of subcollections) {
          if (payload.subArea) {
            console.log("subarea")
            if (payload.tema) {
              console.log("tema")
              if (payload.subTema) {
                console.log("subtema")
                querySnapshot = await getDocs(
                  query(collection(deckDocRef, subcollection),
                    where('area', '==', payload.area),
                    where('subArea', '==', payload.subArea),
                    where('theme', '==', payload.tema),
                    where('subTheme', '==', payload.subTema)
                  )
                );
              } else {
                querySnapshot = await getDocs(
                  query(collection(deckDocRef, subcollection),
                    where('area', '==', payload.area),
                    where('subArea', '==', payload.subArea),
                    where('theme', '==', payload.tema)
                  )
                );
              }
            } else {
              querySnapshot = await getDocs(
                query(collection(deckDocRef, subcollection),
                  where('area', '==', payload.area),
                  where('subArea', '==', payload.subArea)
                )
              );
            }
          } else {
            console.log("area")
            querySnapshot = await getDocs(
              query(collection(deckDocRef, subcollection),
                where('area', '==', payload.area)
              )
            );
          }

          querySnapshot.forEach(doc => {
            const data = doc.data();
            const difficultyTracking = state.userName[0]?.difficultyTracking || [];
            const userDifficulty = difficultyTracking.find(item => item.refId === data.refId);
            const easiness = userDifficulty ? userDifficulty.easiness : 2.5;

            cards.push({
              question: data.question,
              answer: data.answer,
              questionImage: data.questionImage || null,
              answerImage: data.answerImage || null,
              refId: data.refId,
              easiness: easiness,
            });
          });
        }

        // Função para embaralhar um array
        function shuffleArray(array) {
          for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
          }
          return array;
        }

        // Limita o banco de questões a 50% para usuários freemium
        const availableCards = getters.freemium === 'true' ? cards.slice(0, Math.ceil(cards.length / 2)) : cards;

        // Embaralhar os cartões
        const shuffledCards = shuffleArray([...availableCards]);

        // Selecionar 10 cartões aleatórios
        const randomCards = shuffledCards.slice(0, 10);

        // Ordenar os cartões restantes por dificuldade (easiness)
        const sortedByDifficulty = [...availableCards].sort((a, b) => (a.easiness || Infinity) - (b.easiness || Infinity));

        // Selecionar os 15 cartões mais difíceis
        const mostDifficultCards = sortedByDifficulty.slice(0, 15);

        // Combinar os 5 aleatórios e os 20 mais difíceis
        const finalCards = [...randomCards, ...mostDifficultCards];

        // Atualizar o estado Vuex com os cartões finais
        commit('setFlashcards', finalCards);

        console.log("Cartões selecionados:");
        console.log(finalCards);

      } catch (error) {
        console.error('Erro ao buscar os cards:', error.message);
      }
    },

    // Action para gerar cards no formato 2.0 (Firestore: new_flashcards_TEMFC + SM-2)
    async generateCardsV2({ commit, state, getters }, payload = {}) {
      try {
        commit('setLoading', true);

        // Se for continuação ("Mais 25 cards") usando o pool restante
        if (payload.isContinue && state.deckCardsPoolV2 && state.deckCardsPoolV2.length > 0) {
          const sessionCards = state.deckCardsPoolV2.slice(0, 25);
          const remainingCards = state.deckCardsPoolV2.slice(25);
          commit('setFlashcardsV2', sessionCards);
          commit('setDeckCardsPoolV2', remainingCards);
          commit('setLoading', false);
          return;
        }

        const cardsCollectionRef = collection(db, 'new_flashcards_TEMFC');
        let fetchedCards = [];

        // Identifica deck(s) a buscar
        const deckIds = payload.deckIds || (payload.deck_id ? [payload.deck_id] : []);

        if (deckIds.length === 1) {
          // Busca simples por folha canônica
          const q = query(cardsCollectionRef, where('deck_id', '==', deckIds[0]));
          const snap = await getDocs(q);
          snap.forEach(docSnap => {
            fetchedCards.push({ id: docSnap.id, ...docSnap.data() });
          });
        } else if (deckIds.length > 1) {
          // Firestore suporta no máximo 30 itens na cláusula 'in'
          const chunkSize = 30;
          for (let i = 0; i < deckIds.length; i += chunkSize) {
            const chunk = deckIds.slice(i, i + chunkSize);
            const q = query(cardsCollectionRef, where('deck_id', 'in', chunk));
            const snap = await getDocs(q);
            snap.forEach(docSnap => {
              fetchedCards.push({ id: docSnap.id, ...docSnap.data() });
            });
          }
        } else {
          // Se nenhum deck específico foi passado, busca a coleção inteira (1.752 cards)
          const snap = await getDocs(cardsCollectionRef);
          snap.forEach(docSnap => {
            fetchedCards.push({ id: docSnap.id, ...docSnap.data() });
          });
        }

        // Histórico de repetição espaçada SM-2 da versão 2.0
        const userData = (state.userName && state.userName.length > 0) ? state.userName[0] : {};
        const difficultyTrackingV2 = userData.difficultyTrackingV2 || [];

        // Mapeia histórico do aluno por card_id / refId
        const trackingMap = new Map();
        difficultyTrackingV2.forEach(item => {
          const key = item.card_id || item.refId;
          if (key) trackingMap.set(key, item);
        });

        const today = getTodayDateString();

        // Mapear campos para garantir interoperabilidade
        const mappedCards = fetchedCards.map(c => {
          const cardId = c.id || c.card_id || c.refId;
          const sm2Record = trackingMap.get(cardId);
          return {
            card_id: cardId,
            refId: cardId,
            deck_id: c.deck_id || '',
            tipo: c.tipo || 'basico',
            frente: c.frente || c.question || '',
            verso: c.verso || c.answer || '',
            por_que: c.por_que || '',
            peso_prova: Number(c.peso_prova) || 0,
            question: c.frente || c.question || '',
            answer: c.verso || c.answer || '',
            questionImage: c.imagem || c.questionImage || null,
            answerImage: c.answerImage || null,
            subtema: c.subtema || c.subTheme || '',
            grande_area: c.grande_area || c.theme || '',
            sm2Record: sm2Record || null,
            easiness: sm2Record ? sm2Record.easiness : 2.5,
          };
        });

        // Categorização SM-2: Devidos (DUE), Novos (NEW), e Agendados (LEARNING)
        const dueCards = [];
        const newCardsRaw = [];
        const learningCards = [];

        mappedCards.forEach(card => {
          if (!card.sm2Record) {
            newCardsRaw.push(card);
          } else if (isCardDue(card.sm2Record, today)) {
            dueCards.push(card);
          } else {
            learningCards.push(card);
          }
        });

        // Limita a 50% dos cards NOVOS para Freemium (protegendo cards devidos já estudados)
        const isFreemium = getters.freemium === 'true' || getters.freemium === true;
        const newCards = isFreemium ? newCardsRaw.slice(0, Math.ceil(newCardsRaw.length / 2)) : newCardsRaw;

        // 1. Devidos: prioriza os com menor facilidade (mais difíceis)
        dueCards.sort((a, b) => (a.easiness || 2.5) - (b.easiness || 2.5));

        // 2. Novos: agrupados por tipo e ordenados por peso de prova decrescente
        const basicos = newCards.filter(c => c.tipo === 'basico').sort((a, b) => b.peso_prova - a.peso_prova);
        const clozes = newCards.filter(c => c.tipo === 'cloze').sort((a, b) => b.peso_prova - a.peso_prova);
        const miniCasos = newCards.filter(c => c.tipo === 'mini_caso').sort((a, b) => b.peso_prova - a.peso_prova);

        // Intercalação de tipos (round-robin)
        const interleavedNew = [];
        const maxLen = Math.max(basicos.length, clozes.length, miniCasos.length);
        for (let i = 0; i < maxLen; i++) {
          if (i < basicos.length) interleavedNew.push(basicos[i]);
          if (i < clozes.length) interleavedNew.push(clozes[i]);
          if (i < miniCasos.length) interleavedNew.push(miniCasos[i]);
        }

        // Fila de estudo: Se for modo somente devidos, foca exclusivamente nos cards devidos
        const isOnlyDue = payload.onlyDue === true || payload.deck_title === 'Revisão do Dia (SM-2)';
        let fullQueue = [];
        if (isOnlyDue) {
          fullQueue = [...dueCards];
        } else {
          fullQueue = [...dueCards, ...interleavedNew];
          // Adiciona cards futuros em aprendizado apenas se a fila estiver curta e o card não tiver sido revisado hoje
          if (fullQueue.length < 25 && learningCards.length > 0) {
            const eligibleLearning = learningCards.filter(c => {
              if (!c.sm2Record || !c.sm2Record.lastReviewed) return true;
              const lrDate = c.sm2Record.lastReviewed.includes('T') ? c.sm2Record.lastReviewed.split('T')[0] : c.sm2Record.lastReviewed;
              return lrDate !== today;
            });
            eligibleLearning.sort((a, b) => (a.easiness || 2.5) - (b.easiness || 2.5));
            fullQueue.push(...eligibleLearning);
          }
        }

        const sessionCards = fullQueue.slice(0, 25);
        const remainingCards = fullQueue.slice(25);

        commit('setActiveDeckV2', {
          deck_id: payload.deck_id || (deckIds.length === 1 ? deckIds[0] : 'multi'),
          title: payload.deck_title || 'Flashcards 2.0',
          totalPool: fullQueue.length,
          dueCount: dueCards.length,
          newCount: newCards.length
        });
        commit('setFlashcardsV2', sessionCards);
        commit('setDeckCardsPoolV2', remainingCards);

        console.log(`[Flashcards 2.0] Lote gerado: ${sessionCards.length} cards (Total no pool: ${fullQueue.length})`);
      } catch (error) {
        console.error('Erro ao gerar cards 2.0:', error);
      } finally {
        commit('setLoading', false);
      }
    },

    // Action para salvar progresso dos cards 2.0 (totalmente isolado do legado)
    async saveCardsV2({ commit, state }, payload) {
      try {
        const userEmail = auth.currentUser ? auth.currentUser.email : (state.leadEmail || '');
        if (!userEmail) return;

        const usersRef = collection(db, 'users');
        const userDataArray = state.userName;
        if (!userDataArray || userDataArray.length === 0) return;

        const currentDate = new Date();
        const day = currentDate.getDate();
        const month = currentDate.getMonth() + 1;
        const year = currentDate.getFullYear();
        const currentDateStr = `${day}/${month}/${year}`;
        const totalCardsReviewed = payload.total || 0;

        // 1. Atualizar histórico diário na v2 (datesV2) e sinc com dates legado
        let userDates = userDataArray[0].dates || [];
        let dateIdx = userDates.findIndex(d => d.date === currentDateStr);
        if (dateIdx !== -1) {
          userDates[dateIdx].cards += totalCardsReviewed;
        } else {
          userDates.push({ date: currentDateStr, cards: totalCardsReviewed });
        }
        userDataArray[0].dates = [...userDates];

        let userDatesV2 = userDataArray[0].datesV2 || [];
        let dateV2Idx = userDatesV2.findIndex(d => d.date === currentDateStr);
        if (dateV2Idx !== -1) {
          userDatesV2[dateV2Idx].cards += totalCardsReviewed;
        } else {
          userDatesV2.push({ date: currentDateStr, cards: totalCardsReviewed });
        }
        userDataArray[0].datesV2 = [...userDatesV2];

        // 2. Atualizar contadores
        userDataArray[0].totalCards = (userDataArray[0].totalCards || 0) + totalCardsReviewed;
        userDataArray[0].totalCardsV2 = (userDataArray[0].totalCardsV2 || 0) + totalCardsReviewed;

        // 3. Atualizar difficultyTrackingV2 (registros SM-2)
        let trackingV2 = [...(userDataArray[0].difficultyTrackingV2 || [])];
        if (Array.isArray(payload.difficultyTrackingV2)) {
          payload.difficultyTrackingV2.forEach(newItem => {
            const cardId = newItem.card_id || newItem.refId;
            const idx = trackingV2.findIndex(item => (item.card_id === cardId || item.refId === cardId));
            if (idx !== -1) {
              trackingV2[idx] = { ...trackingV2[idx], ...newItem };
            } else {
              trackingV2.push(newItem);
            }
          });
        }
        userDataArray[0].difficultyTrackingV2 = trackingV2;

        // 4. Gravar no Firestore
        const q = query(usersRef, where('email', '==', userEmail));
        const querySnapshot = await getDocs(q);
        await Promise.all(
          querySnapshot.docs.map(docSnap =>
            updateDoc(docSnap.ref, {
              totalCards: userDataArray[0].totalCards,
              totalCardsV2: userDataArray[0].totalCardsV2,
              dates: userDataArray[0].dates,
              datesV2: userDataArray[0].datesV2,
              difficultyTrackingV2: trackingV2,
            })
          )
        );

        commit('setUserName', userDataArray);
        console.log(`[Flashcards 2.0] Progresso SM-2 salvo com sucesso.`);
      } catch (error) {
        console.error('Erro ao salvar progresso dos flashcards 2.0:', error);
      }
    },

    async postSuggestionFlashcardsV2({ commit }, payload) {
      payload.email = auth.currentUser ? auth.currentUser.email : (this.state.leadEmail || '');
      payload.action = 'editFeedbackFlashcardsV2';
      return axios.get(TABLE_URL_FLASHCARDS, { params: payload }, {
        headers: { 'Cache-Control': 'no-cache', 'Pragma': 'no-cache', 'Expires': '0' }
      });
    },

    //Action for cleaning the error state.
    clearError({ commit }) {
      commit('clearError')
    },
    // Action for loading items from Google Sheets database
    async checkAdmin({ commit }) {
      commit('setLoading', true); // Habilita o loading
      try {
        const payload = {};
        payload.email = auth.currentUser ? auth.currentUser.email : (this.state.leadEmail || '');
        const response = await axios.get(
          TABLE_URL + '?action=checkAdmin',
          { params: payload },
          {
            headers: {
              'Cache-Control': 'no-cache, no-store, must-revalidate',
              Pragma: 'no-cache',
              Expires: '0',
            },
          }
        );
        if (response.status < 400) {
          commit('setAdmin', response.data.status);
          console.log(response.data.status);
          commit('setFreemium', response.data.freemium);
          console.log(response.data.freemium);
          commit('setchallengeProgress', response.data.challengeProgress);
          console.log(response.data.challengeProgress);
        } else {
          console.log('failure');
        }
      } catch (error) {
        console.error('Erro em checkAdmin:', error);
      } finally {
        commit('setLoading', false); // Desabilita o loading
      }
    },
    // Action for loading items from Google Sheets database
    // async loadItems({commit, state}){
    //   if (!state.loadedItems || state.loadedItems.length === 0) {
    //     commit('setLoading', true);
    //   }
    //   const  payload = {}
    //   payload.email = auth.currentUser ? auth.currentUser.email : (this.state.leadEmail || '')
    //   let response = await axios.get(TABLE_URL+'?action=getData',{params: payload},{
    //     headers: {
    //       'Cache-Control': 'no-cache, no-store, must-revalidate',
    //       Pragma: 'no-cache',
    //       Expires: '0',
    //     }})

    //   if(response.status < 400){
    //     let filteredItems = []
    //     filteredItems = response.data.items   
    //     filteredItems.db = response.data.db  
    //     var db = response.data.db  
    //     var noq = response.data.noq
    //     var noqd = response.data.noqd
    //     var questoesRespondidas = response.data.questoesRespondidas || []; // ← ADICIONE

    //     commit('setLoadedItems', filteredItems.reverse())
    //     commit('setDbName', db)
    //     commit('setNoqName', noq)
    //     commit('setNoqdName', noqd)
    //     commit('setQuestoesRespondidas', questoesRespondidas) // ← ADICIONE
    //     commit('setLoading', false)
    //     console.log('Questões respondidas:', questoesRespondidas);
    //   } else{
    //     console.log("failure")
    //     commit('setLoading', false)
    //   }
    // },

    async loadItems({ commit, state }) {
      if (!state.loadedItems || state.loadedItems.length === 0) {
        commit('setLoading', true);
      }
      const payload = {}
      payload.email = auth.currentUser ? auth.currentUser.email : (this.state.leadEmail || '')
      if (state.admin && state.admin !== '') {
        payload.db = state.admin
      }
      try {
        let response = await axios.get(TABLE_URL + '?action=getData', { params: payload }, {
          headers: {
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            Pragma: 'no-cache',
            Expires: '0',
          }
        })

        if (response.status < 400) {
          // Desestrutura a resposta que vem do backend
          const { db, questoesRespondidas, questoesErradas } = response.data;

          //commit('setDbName', db)
          commit('setQuestoesRespondidas', questoesRespondidas)
          commit('setQuestoesErradas', questoesErradas)
          commit('setLoading', false)

          //console.log('DB:', db);
          console.log('Store: Questões respondidas:', questoesRespondidas);
          console.log('Store: Questões erradas:', questoesErradas);

        } else {
          console.log("failure")
          commit('setLoading', false)
        }
      } catch (error) {
        console.error('Erro ao carregar items:', error)
        commit('setLoading', false)
      }
    },
    // Action for loading items from Google Sheets database
    async loadItemsChallenge({ commit, state }) {
      if (!state.challengeloadedItems || state.challengeloadedItems.length === 0) {
        commit('setLoading', true); // Only set loading if loadedItems is empty
      }
      // Use axios to make a get request
      const payload = {}
      payload.email = auth.currentUser ? auth.currentUser.email : (this.state.leadEmail || '')
      if (state.admin && state.admin !== '') {
        payload.db = state.admin
      }
      let response = await axios.get(TABLE_URL + '?action=getDataChallenge', { params: payload }, {
        headers: {
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          Pragma: 'no-cache',
          Expires: '0',
        }
      })
      // Test response for error states and proceed to filter items on client side
      if (response.status < 400) {
        let filteredItems = []
        filteredItems = response.data.items
        filteredItems.db = response.data.db
        var db = response.data.db
        var noq = response.data.noq
        var noqd = response.data.noqd
        var noqcorrect = response.data.noqcorrect
        var noqwrong = response.data.noqwrong

        // Save data loaded from server
        commit('challengesetLoadedItems', filteredItems)
        commit('challengesetDbName', db)
        commit('challengesetNoqName', noq)
        commit('challengesetNoqdName', noqd)
        commit('challengesetNoqcorrectName', noqcorrect)
        commit('challengesetNoqwrongName', noqwrong)
        console.log(filteredItems);
        console.log(noqcorrect);
        commit('setLoading', false)

      } else {
        // If there's an error on the request show a Modal
        console.log("failure")
        commit('setLoading', false)
      }
    },
    // Action for loading raw items from Google Sheets database
    async loadRawQuestions({ commit }) {
      commit('setLoading', true)
      // Use axios to make a get request
      const payload = {}
      payload.email = auth.currentUser ? auth.currentUser.email : (this.state.leadEmail || '')
      let response = await axios.get(TABLE_URL + '?action=getRawQuestions', { params: payload }, {
        headers: {
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          Pragma: 'no-cache',
          Expires: '0',
        }
      })
      // Test response for error states and proceed to filter items on client side
      if (response.status < 400) {
        let filteredItems = []
        filteredItems = response.data.items
        // Save data loaded from server
        commit('setLoadedRawQuestions', filteredItems)
        commit('setLoading', false)
        console.log(filteredItems)
      } else {
        // If there's an error on the request show a Modal
        console.log("failure")
        commit('setLoading', false)
      }
    },

    async loadGabaritoSimulados({ commit, state }) {
      commit('setLoading', true)
      // Use axios to make a get request
      const payload = {}
      payload.email = auth.currentUser ? auth.currentUser.email : (this.state.leadEmail || '')
      if (state.admin && state.admin !== '') {
        payload.db = state.admin
      }
      let response = await axios.get(TABLE_URL + '?action=getGabaritoSimulados', { params: payload }, {
        headers: {
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          Pragma: 'no-cache',
          Expires: '0',
        }
      })
      // Test response for error states and proceed to filter items on client side
      if (response.status < 400) {
        let filteredItems = response.data.items || []
        filteredItems.db = response.data.db
        var db = response.data.db
        // Save data loaded from server
        commit('setLoadedGabaritoSimulados', filteredItems)
        commit('setDbName', db)
        commit('setLoading', false)
        console.log("SIMULADO")

        console.log(filteredItems)
        console.log(db)
      } else {
        // If there's an error on the request show a Modal
        console.log("failure")
        commit('setLoading', false)
      }
    },

    // Action for loading items from Google Sheets database
    async loadGabarito({ commit, state }) {
      commit('setLoading', true)
      // Use axios to make a get request
      const payload = {}
      payload.email = auth.currentUser ? auth.currentUser.email : (this.state.leadEmail || '')
      if (state.admin && state.admin !== '') {
        payload.db = state.admin
      }
      let response = await axios.get(TABLE_URL + '?action=getGabarito', { params: payload }, {
        headers: {
          'Cache-Control': 'no-cache', // Adicione este cabeçalho
          'Pragma': 'no-cache',
          'Expires': '0'
        }
      })
      // Test response for error states and proceed to filter items on client side
      if (response.status < 400) {
        let filteredItems = response.data.items || []
        filteredItems.db = response.data.db
        var db = response.data.db
        // Save data loaded from server
        commit('setLoadedGabarito', filteredItems)
        commit('setDbName', db)
        commit('setLoading', false)
        console.log(filteredItems)
        console.log(db)
      } else {
        // If there's an error on the request show a Modal
        console.log("failure")
        commit('setLoading', false)
      }
    },

    // Action for loading items from Google Sheets database
    async loadSimuladosPraticoWrong({ commit, state }) {
      commit('setLoading', true)
      // Use axios to make a get request
      const payload = {}
      payload.email = auth.currentUser ? auth.currentUser.email : (this.state.leadEmail || '')
      if (state.admin && state.admin !== '') {
        payload.db = state.admin
      }
      let response = await axios.get(TABLE_URL + '?action=getSimuladosPraticoWrong', { params: payload }, {
        headers: {
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          'Expires': '0'
        }
      })
      // Test response for error states and proceed to filter items on client side
      if (response.status < 400) {
        let filteredItems = []
        filteredItems = response.data.items
        filteredItems.db = response.data.db
        var db = response.data.db
        // Save data loaded from server
        commit('setLoadedSimuladosPraticoWrong', filteredItems)
        commit('setDbName', db)
        commit('setLoading', false)
        console.log(filteredItems)
        console.log(db)
      } else {
        // If there's an error on the request show a Modal
        console.log("failure")
        commit('setLoading', false)
      }
    },

    // Action for loading items from Google Sheets database
    async loadSimuladosWrong({ commit, state }) {
      commit('setLoading', true)
      // Use axios to make a get request
      const payload = {}
      payload.email = auth.currentUser ? auth.currentUser.email : (this.state.leadEmail || '')
      if (state.admin && state.admin !== '') {
        payload.db = state.admin
      }
      let response = await axios.get(TABLE_URL + '?action=getSimuladosWrong', { params: payload }, {
        headers: {
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          'Expires': '0'
        }
      })
      // Test response for error states and proceed to filter items on client side
      if (response.status < 400) {
        let filteredItems = []
        filteredItems = response.data.items
        filteredItems.db = response.data.db
        var db = response.data.db
        // Save data loaded from server
        commit('setLoadedSimuladosWrong', filteredItems)
        commit('setDbName', db)
        commit('setLoading', false)
        console.log(filteredItems)
        console.log(db)
      } else {
        // If there's an error on the request show a Modal
        console.log("failure")
        commit('setLoading', false)
      }
    },

    // Action for loading items from Google Sheets database
    async loadSimulados({ commit, state }) {
      commit('setLoading', true)
      // Use axios to make a get request
      const payload = {}
      payload.email = auth.currentUser ? auth.currentUser.email : (this.state.leadEmail || '')
      if (state.admin && state.admin !== '') {
        payload.db = state.admin
      }
      console.log('Payload loadSimulados:', payload)
      let response = await axios.get(TABLE_URL + '?action=getSimulados', { params: payload }, {
        headers: {
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          'Expires': '0'
        }
      })
      // Test response for error states and proceed to filter items on client side
      if (response.status < 400) {
        let filteredItems = []
        filteredItems = response.data.items
        filteredItems.db = response.data.db
        var db = response.data.db
        // Save data loaded from server
        commit('setLoadedSimulados', filteredItems)
        commit('setDbName', db)
        commit('setLoading', false)
        console.log(filteredItems)
        console.log(db)
      } else {
        // If there's an error on the request show a Modal
        console.log("failure")
        commit('setLoading', false)
      }
    },
    // Action for loading items from Google Sheets database
    async loadSimulados2({ commit, state }) {
      commit('setLoading', true)
      // Use axios to make a get request
      const payload = {}
      payload.email = auth.currentUser ? auth.currentUser.email : (this.state.leadEmail || '')
      if (state.admin && state.admin !== '') {
        payload.db = state.admin
      }
      let response = await axios.get(TABLE_URL + '?action=getSimuladosPratico', { params: payload }, {
        headers: {
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          Pragma: 'no-cache',
          Expires: '0',
        }
      })
      // Test response for error states and proceed to filter items on client side
      if (response.status < 400) {
        let filteredItems = []
        filteredItems = response.data.items
        filteredItems.db = response.data.db
        var db = response.data.db
        // Save data loaded from server
        commit('setLoadedSimulados2', filteredItems)
        commit('setDbName', db)
        commit('setLoading', false)
        console.log(filteredItems)
        console.log(db)
      } else {
        // If there's an error on the request show a Modal
        console.log("failure")
        commit('setLoading', false)
      }
    },

    // Action for loading items from Google Sheets database
    async loadResults({ commit, state }, payload) {
      commit('setLoading', true)
      payload = payload || {};
      payload.email = auth.currentUser ? auth.currentUser.email : (this.state.leadEmail || '')
      if (state.admin && state.admin !== '') {
        payload.db = state.admin
      }
      // Use axios to make a get request
      let response = await axios.get(TABLE_URL + '?action=getResults', { params: payload }, {
        headers: {
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          Pragma: 'no-cache',
          Expires: '0',
        }
      })
      // Test response for error states and proceed to filter items on client side
      if (response.status < 400) {
        let filteredItems = []
        // If email search is needed
        if (payload.search == true) {
          // console.log(response.data);
          // All the data filtering per email from what has been received from the server
          response.data.items.forEach(element => {
            element.date = new Date(element.date)
          })
          filteredItems = response.data.items.filter(x => {
            return x.email == auth.currentUser.email
          })
        } else {
          // If search not needed display everything
          filteredItems = response.data.items
        }
        // Save data loaded from server
        commit('setLoadedResults', filteredItems.reverse())
        //console.log(filteredItems)
        commit('setLoading', false)
      } else {
        // If there's an error on the request show a Modal
        console.log("failure")
        commit('setLoading', false)
      }
    },

    async postCsat({ commit }, payload) {
      //commit('setLoading', LOADING_COLOR)
      // Add email and action to payload
      payload.email = auth.currentUser ? auth.currentUser.email : (this.state.leadEmail || '')
      payload.action = 'editCsat'
      console.log(payload)

      // Run network status plugin
      //let network = await Network.getStatus()

      axios.get(TABLE_URL, { params: payload }, {
        headers: {
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          Pragma: 'no-cache',
          Expires: '0',
        }
      })
        .then(async (response) => {
          // Check return Status code and display a Modal if ok
          if (response.status < 400) {
            await console.log("salvo com sucesso")
            commit('setLoading', false)
          } else {
            // If there's an request error show a Modal accordingly
            await console.log("erro ao salvar")
            commit('setLoading', false)
          }
        })
    },

    async postSimulado({ commit, state }, payload) {
      //commit('setLoading', LOADING_COLOR)
      // Add email and action to payload
      payload.email = auth.currentUser ? auth.currentUser.email : (this.state.leadEmail || '')
      if (state.admin && state.admin !== '') {
        payload.db = state.admin
      }
      payload.action = 'editSimuladosResults'
      console.log(payload)

      // Run network status plugin
      //let network = await Network.getStatus()

      axios.get(TABLE_URL, { params: payload }, {
        headers: {
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          Pragma: 'no-cache',
          Expires: '0',
        }
      })
        .then(async (response) => {
          // Check return Status code and display a Modal if ok
          if (response.status < 400) {
            await console.log("salvo com sucesso")
            commit('setLoading', false)
          } else {
            // If there's an request error show a Modal accordingly
            await console.log("erro ao salvar")
            commit('setLoading', false)
          }
        })
    },

    async postItems({ commit }, payload) {
      //commit('setLoading', LOADING_COLOR)
      // Add email and action to payload
      console.log(payload)
      payload.email = auth.currentUser ? auth.currentUser.email : (this.state.leadEmail || '')
      payload.action = 'editResults'
      payload.db = this.state.admin
      // Run network status plugin
      //let network = await Network.getStatus()

      axios.get(TABLE_URL, { params: payload }, {
        headers: {
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          Pragma: 'no-cache',
          Expires: '0',
        }
      })
        .then(async (response) => {
          // Check return Status code and display a Modal if ok
          if (response.status < 400) {
            await console.log("salvo com sucesso")
            commit('setLoading', false)
          } else {
            // If there's an request error show a Modal accordingly
            await console.log("erro ao salvar")
            commit('setLoading', false)
          }
        })
    },
    async postItemsChallenge({ commit, state }, payload) {
      //commit('setLoading', LOADING_COLOR)
      // Add email and action to payload
      console.log("payloaaddd")
      console.log(payload)
      payload.email = auth.currentUser ? auth.currentUser.email : (this.state.leadEmail || '')
      payload.action = 'editResultsChallenge'
      if (state.admin && state.admin !== '') {
        payload.db = state.admin
      }
      // Run network status plugin
      //let network = await Network.getStatus()``

      axios.get(TABLE_URL, { params: payload }, {
        headers: {
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          Pragma: 'no-cache',
          Expires: '0',
        }
      })
        .then(async (response) => {
          // Check return Status code and display a Modal if ok
          if (response.status < 400) {
            await console.log("salvo com sucesso")
            commit('setLoading', false)
          } else {
            // If there's an request error show a Modal accordingly
            await console.log("erro ao salvar")
            commit('setLoading', false)
          }
        })
    },

    async saveEditedItem({ commit }, payload) {
      //commit('setLoading', LOADING_COLOR)
      payload.admin = this.state.admin
      // Add email and action to payload
      console.log(payload)
      payload.email = auth.currentUser ? auth.currentUser.email : (this.state.leadEmail || '')
      payload.action = 'editQuestions'
      // Run network status plugin
      //let network = await Network.getStatus()

      axios.get(TABLE_URL, { params: payload }, {
        headers: {
          'Cache-Control': 'no-cache', // Adicione este cabeçalho
          'Pragma': 'no-cache',
          'Expires': '0'
        }
      })
        .then(async (response) => {
          // Check return Status code and display a Modal if ok
          if (response.status < 400) {
            await console.log("salvo com sucesso")
            commit('setLoading', false)
          } else {
            // If there's an request error show a Modal accordingly
            await console.log("erro ao salvar")
            commit('setLoading', false)
          }
        })
    },

    async deleteEditedItem({ commit }, payload) {
      //commit('setLoading', LOADING_COLOR)
      payload.admin = this.state.admin
      // Add email and action to payload
      console.log(payload)
      payload.email = auth.currentUser ? auth.currentUser.email : (this.state.leadEmail || '')
      payload.action = 'deleteQuestions'
      // Run network status plugin
      //let network = await Network.getStatus()

      axios.get(TABLE_URL, { params: payload }, {
        headers: {
          'Cache-Control': 'no-cache', // Adicione este cabeçalho
          'Pragma': 'no-cache',
          'Expires': '0'
        }
      })
        .then(async (response) => {
          // Check return Status code and display a Modal if ok
          if (response.status < 400) {
            await console.log("salvo com sucesso")
            commit('setLoading', false)
          } else {
            // If there's an request error show a Modal accordingly
            await console.log("erro ao salvar")
            commit('setLoading', false)
          }
        })
    },

    async saveQuestionReset({ commit }) {
      const payload = {}
      //commit('setLoading', LOADING_COLOR)
      //console.log(this.state.admin)
      payload.db = this.state.admin
      // Add email and action to payload
      payload.email = auth.currentUser ? auth.currentUser.email : (this.state.leadEmail || '')
      console.log(payload)
      payload.action = 'resetQuestions'
      // Run network status plugin
      //let network = await Network.getStatus()

      axios.get(TABLE_URL, { params: payload }, {
        headers: {
          'Cache-Control': 'no-cache', // Adicione este cabeçalho
          'Pragma': 'no-cache',
          'Expires': '0'
        }
      })
        .then(async (response) => {
          // Check return Status code and display a Modal if ok
          if (response.status < 400) {
            await console.log("salvo com sucesso")
            commit('setLoading', false)
          } else {
            // If there's an request error show a Modal accordingly
            await console.log("erro ao salvar")
            commit('setLoading', false)
          }
        })
    },

    async createItem({ commit }, payload) {
      //commit('setLoading', LOADING_COLOR)
      payload.admin = this.state.admin
      // Add email and action to payload
      console.log(payload)
      payload.email = auth.currentUser ? auth.currentUser.email : (this.state.leadEmail || '')
      payload.action = 'createQuestions'
      // Run network status plugin
      //let network = await Network.getStatus()

      axios.get(TABLE_URL, { params: payload }, {
        headers: {
          'Cache-Control': 'no-cache', // Adicione este cabeçalho
          'Pragma': 'no-cache',
          'Expires': '0'
        }
      })
        .then(async (response) => {
          // Check return Status code and display a Modal if ok
          if (response.status < 400) {
            await console.log("salvo com sucesso")
            commit('setLoading', false)
          } else {
            // If there's an request error show a Modal accordingly
            await console.log("erro ao salvar")
            commit('setLoading', false)
          }
        })
    },

    async postFlashcards({ commit }, payload) {
      //commit('setLoading', LOADING_COLOR)
      // Add email and action to payload
      console.log(payload)
      payload.email = auth.currentUser ? auth.currentUser.email : (this.state.leadEmail || '')
      payload.action = 'editResultsFlashcards'
      // Run network status plugin
      //let network = await Network.getStatus()

      axios.get(TABLE_URL, { params: payload }, {
        headers: {
          'Cache-Control': 'no-cache', // Adicione este cabeçalho
          'Pragma': 'no-cache',
          'Expires': '0'
        }
      })
        .then(async (response) => {
          // Check return Status code and display a Modal if ok
          if (response.status < 400) {
            await console.log("salvo com sucesso")
            commit('setLoading', false)
          } else {
            // If there's an request error show a Modal accordingly
            await console.log("erro ao salvar")
            commit('setLoading', false)
          }
        })
    },

    async postSuggestionFlashcards({ commit }, payload) {
      // Add email and action to payload
      console.log(payload)
      payload.email = auth.currentUser ? auth.currentUser.email : (this.state.leadEmail || '')
      payload.action = 'editFeedback'
      // Run network status plugin
      //let network = await Network.getStatus()

      axios.get(TABLE_URL_FLASHCARDS, { params: payload }, {
        headers: {
          'Cache-Control': 'no-cache', // Adicione este cabeçalho
          'Pragma': 'no-cache',
          'Expires': '0'
        }
      })
        .then(async (response) => {
          // Check return Status code and display a Modal if ok
          if (response.status < 400) {
            await console.log("salvo com sucesso")
            commit('setLoading', false)
          } else {
            // If there's an request error show a Modal accordingly
            await console.log("erro ao salvar")
            commit('setLoading', false)
          }
        })
    },


    async postSuggestion({ commit }, payload) {
      // Add email and action to payload
      console.log(payload)
      payload.email = auth.currentUser ? auth.currentUser.email : (this.state.leadEmail || '')
      payload.action = 'editFeedback'
      payload.db = this.state.admin

      // Run network status plugin
      //let network = await Network.getStatus()

      axios.get(TABLE_URL, { params: payload }, {
        headers: {
          'Cache-Control': 'no-cache', // Adicione este cabeçalho
          'Pragma': 'no-cache',
          'Expires': '0'
        }
      })
        .then(async (response) => {
          // Check return Status code and display a Modal if ok
          if (response.status < 400) {
            await console.log("salvo com sucesso")
            commit('setLoading', false)
          } else {
            // If there's an request error show a Modal accordingly
            await console.log("erro ao salvar")
            commit('setLoading', false)
          }
        })
    },

    async loadSimuladosResults({ commit, state }, payload) {
      commit('setLoading', true); // Ativa o estado de carregamento
      payload.email = auth.currentUser ? auth.currentUser.email : (this.state.leadEmail || ''); // Adiciona o email ao payload
      if (state.admin && state.admin !== '') {
        payload.db = state.admin
      }
      try {
        // Faz a requisição para obter os resultados dos simulados
        const response = await axios.get(TABLE_URL + '?action=sendSimuladosResults', { params: payload }, {
          headers: {
            'Cache-Control': 'no-cache', // Adicione este cabeçalho
            'Pragma': 'no-cache',
            'Expires': '0'
          }
        });

        if (response.status < 400) {
          // Salva os dados retornados no estado Vuex
          commit('setLoadedSimuladosResults', response.data.items.reverse());
          console.log('Simulados Results:', response.data.items);
        } else {
          console.error('Erro ao carregar os resultados dos simulados');
        }
      } catch (error) {
        console.error('Erro na requisição de simulados:', error.message);
      } finally {
        commit('setLoading', false); // Desativa o estado de carregamento
      }
    },

  },
  modules: {
    // módulos adicionais aqui
  },
});